// FIRST, and deliberately: three 0.135 declares vColor for
// USE_INSTANCING_COLOR in the vertex shader but not in the fragment
// shader, so every per-instance colour this viewer writes (diff overlay,
// ghost tint, selection highlight) was computed and then discarded on any
// material without vertexColors. Patching the ShaderChunk registry has to
// happen before the first material compiles.
import "../viewer/instancingColorPatch";
import Viewer from "../viewer";
// CHANGED: was `import Loader from "../loader";`
// StreamingLoader is a drop-in replacement — same constructor signature,
// falls back to the legacy Loader automatically when glbs.manifestUrl is
// absent. This single import swap activates streaming for any viewer that
// passes a manifestUrl in glbs (see viewer call sites: SocketViewer,
// TimelineViewer, ModelViewer).
import Loader from "../loader/streaming/streamingLoader";

export default class WebGlApp {
  constructor(container, glbs, ReactAPI, line, socketviewer, isIfcProject) {
    this.viewer = new Viewer(
      container,
      ReactAPI,
      line,
      socketviewer,
      isIfcProject
    );
    this.loader = new Loader(this.viewer, glbs, ReactAPI, isIfcProject); //list of uniqId
  }

  // Tear the whole thing down: the streaming session (its tick, workers
  // and any load still in flight), the render loop and window listeners,
  // then the renderer and its GL context. Pages already called
  // WebGL.current.dispose() on unmount, but until 2026-09-18 there was no
  // such method, so every viewer page left its model streaming, drawing
  // and in memory after you navigated away - and the construction
  // tracking page, which mounted its model twice, downloaded it twice.
  dispose() {
    if (this._disposed) return;
    this._disposed = true;
    try { if (this.loader && typeof this.loader.dispose === 'function') this.loader.dispose(); } catch (e) { /* best effort */ }
    const viewer = this.viewer;
    try { if (viewer && typeof viewer.destroy === 'function') viewer.destroy(); } catch (e) { /* best effort */ }
    // After the loop has seen _destroyed, not while it may still draw.
    const renderer = viewer && viewer.renderer;
    if (renderer) {
      requestAnimationFrame(() => {
        try { renderer.dispose(); } catch (e) { /* best effort */ }
        try { if (typeof renderer.forceContextLoss === 'function') renderer.forceContextLoss(); } catch (e) { /* best effort */ }
      });
    }
  }
}